<template>
  <div class="space-between-y">
    <input-item label="角色名称">
      <el-input v-model="form.name" placeholder="角色名称"></el-input>
    </input-item>
    <input-item label="角色说明">
      <el-input v-model="form.desc" placeholder="角色说明"></el-input>
    </input-item>
    <div class="space-between-x container-center">
      <el-button @click="save()" type="primary">{{ utils.string.vIsEmpty(id) ? '新增' : '更新' }}角色</el-button>
      <el-button @click="deleteRole()" v-if="utils.string.vNotEmpty(id)">删除</el-button>
    </div>

  </div>
</template>

<script>
import InputItem from "@/components/base/layout/InputItem.vue";
import {utils} from "@/util/utils";
import {role} from "@/api/role";

export default {
  name: 'RoleUpdate',
  computed: {
    utils() {
      return utils
    }
  },
  components: {InputItem},

  props: {
    id: Number
  },

  data() {
    return {
      form: {
        name: "",
        desc: "",
      },
    };
  },

  created() {
    if (utils.string.vNotEmpty(this.id)) {
      role.getDetail(this.id).then(res => {
        this.form = res.data;
      });
    }
  },

  methods: {
    deleteRole() {
      role.deleteRole(this.id).then(res => {
        if (res.code === 200) {
          this.$message.success("删除成功");
          this.$emit("updated");
        } else {
          this.$message.error(res.msg);
        }
      })
    },

    save() {
      role.saveRole(this.id, this.form.name, this.form.desc).then(res => {
        if (res.code === 200) {
          this.$message.success("保存成功");
          this.$emit("updated");
        } else {
          this.$message.error(res.msg);
        }
      })
    },

  },


};
</script>

<style scoped>
</style>
